import { DesktopWidth } from '../desktop-width/desktop-width'
import { Filters } from './filters'
import { HORIZONTAL_PICKER_LITE_DESKTOP_HEIGHT, FILTER_GROUPS_DESKTOP_HEIGHT } from './layout'
import { FiltersBarProps as Props } from './props'

export const FiltersBarPlaceholder = () => {
  return <div style={{ height: HORIZONTAL_PICKER_LITE_DESKTOP_HEIGHT + FILTER_GROUPS_DESKTOP_HEIGHT }} />
}

export function FiltersBar(props: Props) {
  return (
    <DesktopWidth>
      <Filters {...props} />
    </DesktopWidth>
  )
}

export default FiltersBar
